<template lang="pug">
    .products-template
        .products-template-title
            p   {{ lenguageSelected.content1 }}
        .products-template-content
            .products-template-content-description
                p(v-for="item in lenguageSelected.content2")   {{ item }}
</template>


<script>
export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            lenguage: 'ES',
            lenguageEN: {
                content1: 'What if a street light were capable of more than illumination? ATP envisions a world where  existing infrastructure lowers civic construction costs, increases efficiencies, drives economic growth, engages citizens, and improves city life.',
                content2: [
                    'We have deployed multiple digital infrastructure use cases that maximize existing infrastructure to connect cities across the Andean region to the Internet of Things (IoT) future. With the ability to help improve transportation, public safety, air quality, pedestrian flow, and parking enforcement, the possibilities are endless for what  Digital Infrastructure can bring to city life.',
                    'To learn more about what Smart Cities and Digital Infrastructure can do for municipalities, click the “Contact Us” button to your left.'
                ]
            },

            lenguageES: {
                content1: '¿Qué pasaría si una luminaria fuera capaz de algo más que iluminación? ATP visualiza un mundo donde un poste de luz común reduce los costos de construcción civil, aumenta la eficiencia, impulsa el crecimiento económico, involucra a los ciudadanos y al mismo tiempo, mejora la vida cotidiana en las grandes zonas metropolitanas.',
                content2: [
                    'Hemos desplegado múltiples tipos de infraestructura digital que maximizan diseños existentes para interconectar a las ciudades de la región andina con soluciones y nuevas tecnologías. IoT nos permitirá mejorar el transporte urbano y suburbano, la seguridad pública, la calidad del aire, el flujo de peatones y la vigilancia. Las posibilidades de la tecnología IoT son infinitas y la infraestructura digital de esta nueva etapa será crítica para mejorar los servicios municipales.',
                    'Para obtener más información sobre lo que pueden hacer las tecnologías IoT para el desarrollo de servicios públicos y las construcciones de Ciudades Inteligentes, seleccione el boton de la izquierda para ir a la sección de contacto.',
                ]
            }
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/molecules/PmSmartCities.vue